import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { Landing } from "@/pages/Landing";
import { Dashboard } from "@/pages/Dashboard";
import { Quiz } from "@/pages/Quiz";
import { Audit } from "@/pages/Audit";
import { NameTest } from "@/pages/NameTest";
import { Ask } from "@/pages/Ask";
import { Admin } from "@/pages/Admin";
import { Privacy } from "@/pages/Privacy";
import { Terms } from "@/pages/Terms";
import { Footer } from "@/components/Footer";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <main>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/quiz" element={<Quiz />} />
            <Route path="/audit" element={<Audit />} />
            <Route path="/name-test" element={<NameTest />} />
            <Route path="/ask" element={<Ask />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/admin/chats" element={<Navigate to="/admin?tab=chats" replace />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="top-center" richColors closeButton />
      </BrowserRouter>
    </div>
  );
}

export default App;
